import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop
 * -----------
 * Resets the window scroll to 0 on every route change. We also flip
 * `history.scrollRestoration` to `"manual"` so the browser doesn't race with us
 * and restore the previous position AFTER our reset (which caused pages like
 * /faq to land at the footer when the user clicked a link from the footer of
 * the previous page).
 *
 * Respects anchor links (#foo) by skipping the reset.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (hash) return;
    // Two scrolls — one synchronous, one deferred — so we win the race against
    // the browser's own async restoration on slower devices.
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    const id = requestAnimationFrame(() => window.scrollTo({ top: 0, left: 0, behavior: "auto" }));
    return () => cancelAnimationFrame(id);
  }, [pathname, hash]);

  return null;
}
